module.exports = __webpack_public_path__ + "img/ExtraBoost2.c94d0613.png";